import React from 'react';

interface Benefit {
  icon: string;
  title: string;
  text: string;
}

interface SectionBenefitsProps {
  title: string;
  items: Benefit[];
}

const SectionBenefits: React.FC<SectionBenefitsProps> = ({ title, items }) => (
  <section className="lp-section lp-section--benefits" aria-labelledby="benefits-title">
    <div className="lp-container">
      <h2 id="benefits-title">{title}</h2>
      <div className="lp-benefits-grid">
        {items.map((item, i) => (
          <article key={i}>
            <div className="lp-benefit__icon">
              <i className={item.icon} aria-hidden="true" />
            </div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default SectionBenefits;
